import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

// Simplified schema - only include fields that are actually used in the UI
const SubscriptionProductVariantSchema = z.object({
  externalVariantId: z.string(),
  title: z.string(),
  prices: z.object({ unitPrice: z.string() }),
  image: z
    .object({
      small: z.string().optional(),
      medium: z.string().optional(),
      large: z.string().optional(),
      original: z.string().optional(),
    })
    .optional(),
});

const SubscriptionProductSchema = z.object({
  // Essential fields for product identification and display
  shopifyProductId: z.number().optional(),
  title: z.string(),
  description: z.string().nullish(),
  handle: z.string().optional(),
  images: z
    .array(
      z.object({
        small: z.string().optional(),
        medium: z.string().optional(),
        large: z.string().optional(),
        original: z.string().optional(),
      }),
    )
    .optional(),
  variants: z.array(SubscriptionProductVariantSchema).optional(),
});

export const getSubscriptionProducts = unaryRpc({
  name: "getSubscriptionProducts",
  input: z.object({
    search: z.string().optional(),
    page: z.number().min(1).default(1),
    pageSize: z.number().min(1).max(100).default(20),
  }),
  output: z.object({
    products: z.array(SubscriptionProductSchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
    hasNextPage: z.boolean(),
  }),
});
